import React, {ReactElement, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography
} from '@customink/pigment-react';
import {Box, styled, SvgIcon} from '@mui/material';
import {useFtux, useStoreType} from '../../hooks';
import ProductsIcon from '../../assets/icons/products.svg?com';
import EditIcon from '../../assets/icons/edit.svg?com';
import TagIcon from '../../assets/icons/tag.svg?com';

type NewStoreDialogProps = {
  storeSlug: string;
};

const NewStoreDialog: React.FC<NewStoreDialogProps> = ({
  storeSlug
}: NewStoreDialogProps): ReactElement => {
  const history = useHistory();
  const ftux = useFtux();
  const [newStoreDialogOpen, setNewStoreDialogOpen] = useState(ftux);
  const {isStoreTypeSelfServe} = useStoreType();

  const handleClose = () => {
    setNewStoreDialogOpen(false);
    history.push(`/${storeSlug}/manage/dashboard`);
  };

  const DialogContentItem = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '0.75rem',
    fontWeight: 600,
    marginBottom: '1rem'
  }));

  return isStoreTypeSelfServe ? (
    <Dialog
      title="Your new store is ready for you!"
      titleSx={{
        fontSize: '3rem',
        fontWeight: '700',
        paddingBottom: '1.5rem'
      }}
      padding={{
        paddingTop: '1.5rem',
        paddingRight: '2.5rem',
        paddingBottom: '1.5rem',
        paddingLeft: '2.5rem'
      }}
      width="lg"
      surfaceSx={{maxWidth: '700px'}}
      onClose={handleClose}
      open={newStoreDialogOpen}>
      <DialogContent>
        <Box marginBottom="1rem">
          <Typography variant="bodyLong2">
            We can&rsquo;t wait for you to open for business and get your custom
            gear out into the world. All you need to do is:
          </Typography>
        </Box>
        <DialogContentItem>
          <SvgIcon color="secondary" alt="Edit" component={EditIcon} />
          <Typography variant="bodyLong2">
            Customize your store&rsquo;s appearance
          </Typography>
        </DialogContentItem>
        <DialogContentItem>
          <SvgIcon color="secondary" alt="Products" component={ProductsIcon} />
          <Typography variant="bodyLong2">Add products to sell</Typography>
        </DialogContentItem>
        <DialogContentItem>
          <SvgIcon
            color="secondary"
            alt="Tag"
            component={TagIcon}
            viewBox="0 0 24 16"
          />
          <Typography variant="bodyLong2">Open your store</Typography>
        </DialogContentItem>
      </DialogContent>
      <DialogActions
        justifyContent="flex-start"
        sx={{
          paddingBottom: '1.5rem'
        }}>
        <Button size="large" onClick={handleClose}>
          Get Started
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

export default NewStoreDialog;
